import React, { useState } from 'react'

import Modal from 'react-modal'

import { bool, func } from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function GenerateViewerModal({ modalIsOpen, closeModal: handleCloseModal, handleStartGeneration }) {
  const [isChecked, setIsChecked] = useState(false)

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked)
  }

  const handleSubmit = () => {
    if (isChecked) {
      handleStartGeneration()
    }
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={handleCloseModal}
      contentLabel="Generate 3D Viewer Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button
          className="btn btn-transparent overlay-modal--close-inner"
          onClick={handleCloseModal}
          type="button"
        >
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--add-embed">
          <div className="l-inner-large">
            <div className="heading-20 modal-header">Generate 3D viewer</div>
            <p className="text-default u-mb10">
              You can request to automatically generate an interactive 3D viewer for this item
              so buyers can inspect the model directly on the product page.
            </p>

            <div className="u-mb15">
              <p className="text-semibold u-mb5">What will happen:</p>
              <ul className="generate-viewer-modal__list">
                <li>Your uploaded 3D files will be processed into a web-ready preview</li>
                <li>The viewer will be added to this product page</li>
                <li>Downloadable files will remain unchanged</li>
              </ul>
            </div>

            <div className="u-mb15">
              <p className="text-semibold u-mb5">Things to know:</p>
              <ul className="generate-viewer-modal__list">
                <li>Generation may take a few minutes</li>
                <li>If multiple files or parts are included, we'll choose the main model automatically</li>
                <li>You will be able to remove the viewer later</li>
                <li>It will be based on Marmoset 3D viewer technology</li>
              </ul>
            </div>

            <div className="form-check u-mb15">
              <input
                type="checkbox"
                className="form-check-input"
                id="generate-viewer-consent"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label className="form-check-label" htmlFor="generate-viewer-consent">
                I understand and want to generate a 3D viewer for this item
              </label>
            </div>

            <div className="u-text-right">
              <button
                type="button"
                className="btn btn-outline-default btn-fat u-mr10"
                onClick={handleCloseModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary btn-fat"
                onClick={handleSubmit}
                disabled={!isChecked}
              >
                Start generation
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

GenerateViewerModal.propTypes = {
  modalIsOpen: bool.isRequired,
  closeModal: func.isRequired,
  handleStartGeneration: func.isRequired,
}

export default GenerateViewerModal
